import {
  AddBenefitToCartPlanEntryDto,
  BenefitType,
  SelfEnrollType,
  SelfReportType,
} from '@zorro/clients';
import { useFlowId, useMonolithMutation } from '@zorro/web/ui-utils';

import { UsePlanElectionFormSubmitProps } from '../PlanElectionForm';

function resolveBenefitType(
  benefitType: BenefitType,
  hasVisionRider: boolean | undefined
): BenefitType {
  if (
    benefitType === BenefitType.SUPPLEMENTAL_DENTAL &&
    hasVisionRider === true
  ) {
    return BenefitType.SUPPLEMENTAL_COMBINED_DENTAL_VISION;
  }
  return benefitType;
}

type UseBenefitAddToCartProps = (props: {
  onboardingPeriodId: string;
  benefitType: BenefitType;
}) => {
  submitAddToCart: (props: UsePlanElectionFormSubmitProps) => Promise<boolean>;
};

export const useBenefitAddToCart: UseBenefitAddToCartProps = ({
  onboardingPeriodId,
  benefitType,
}) => {
  const flowId = useFlowId();

  const { tryMutate: mutateAddToCart } = useMonolithMutation({
    method: 'benefitsControllerAddBenefitPlanToCart',
    shouldReloadPage: false,
  });

  return {
    submitAddToCart: async ({ data }) => {
      const plans: AddBenefitToCartPlanEntryDto[] = data.plans.map((plan) => ({
        type: resolveBenefitType(benefitType, plan.hasVisionRider),
        insuredIds: plan.whoIsEnrolled,
        plan: {
          benefitsSummaryUrl: plan.benefitsSummaryUrl ?? null,
          selfReportType: SelfReportType.NOT_APPLICABLE,
          selfEnroll: plan.isSelfEnroll
            ? SelfEnrollType.SELF_ENROLL
            : SelfEnrollType.NOT_SELF_ENROLL,
          maxOutOfPocket: plan.maxOutOfPocket ?? null,
          deductible: plan.deductible ?? null,
          carrierName: plan.carrier ?? '',
          externalID: plan.planId ?? null,
          planMarket: plan.planMarket,
          policyType: plan.planType,
          premium: plan.premium,
          name: plan.planName,
          extendedPlanDetails: null,
          isCombinedPlan: false,
          isHsaEligible: plan.isHsaEligible ?? false,
        },
      }));

      const result = await mutateAddToCart([onboardingPeriodId, { plans }], {
        flowId,
      });

      return result.isOk();
    },
  };
};
